var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUeberhoehungPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Ueberhoehung_Plus__Icn/40px/Ueberhoehung_Plus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Ueberhoehung_Plus__Color/20px/Platzhalter-Transparent",
    transform: "translate(10 10)",
    fillRule: "nonzero",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Icn_40px_Ueberhoehung_Plus__Rectangle",
    d: "M0 0H20V20H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Ueberhoehung_Plus__Group",
    opacity: 0.200000003,
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5373623,1.11744336 L31.6832832,20 L2,20 L12.0737404,7.49933865 L14.6722963,10.702 L20.5373623,1.11744336 Z M20.5067078,5 L16.015,12.3424434 L17.9648466,14.8095612 L16.3957461,16.0496917 L14.841,14.0824434 L12.0792436,10.6799044 L6.18029633,18 L28.1802963,18 L20.5067078,5 Z",
    id: ".._.._src_svg_Icn_40px_Ueberhoehung_Plus__Combined-Shape",
    transform: "translate(2.82)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,15 C13.9705627,15 18,19.0294373 18,24 C18,28.9705627 13.9705627,33 9,33 C4.02943725,33 0,28.9705627 0,24 C0,19.0294373 4.02943725,15 9,15 Z M9,17 C5.13400675,17 2,20.1340068 2,24 C2,27.8659932 5.13400675,31 9,31 C12.8659932,31 16,27.8659932 16,24 C16,20.1340068 12.8659932,17 9,17 Z M10,19 L9.999,23 L14,23 L14,25 L9.999,25 L10,29 L8,29 L7.999,25 L4,25 L4,23 L7.999,23 L8,19 L10,19 Z",
    id: ".._.._src_svg_Icn_40px_Ueberhoehung_Plus__Combined-Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12,17 C16.9705627,17 21,21.0294373 21,26 C21,30.9705627 16.9705627,35 12,35 C7.02943725,35 3,30.9705627 3,26 C3,21.0294373 7.02943725,17 12,17 Z M12,19 C8.13400675,19 5,22.1340068 5,26 C5,29.8659932 8.13400675,33 12,33 C15.8659932,33 19,29.8659932 19,26 C19,22.1340068 15.8659932,19 12,19 Z M13,21 L12.999,25 L17,25 L17,27 L12.999,27 L13,31 L11,31 L10.999,27 L7,27 L7,25 L10.999,25 L11,21 L13,21 Z M26.357066,3.11744336 L37.5029869,22 L23.8197037,21.9994434 L23.8197037,19.9994434 L34,20 L26.3264114,7 L21.8347037,14.3424434 L23.7845502,16.8095612 L22.2154498,18.0496917 L20.6607037,16.0824434 L17.8989473,12.6799044 L15.7497037,15.3464434 L14.2907037,13.9684434 L17.893444,9.49933865 L20.492,12.702 L26.357066,3.11744336 Z",
    id: ".._.._src_svg_Icn_40px_Ueberhoehung_Plus__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUeberhoehungPlus);
export default __webpack_public_path__ + "static/media/Ueberhoehung_Plus.77d0ba5dd5930f7bba83df93b8dd76e3.svg";
export { ForwardRef as ReactComponent };